var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBenefitCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#00BB8E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.9187 7.97923C18.3146 8.39115 18.3017 9.04605 17.8897 9.442L10.7152 16.3383L6.11058 11.9122C5.69866 11.5163 5.68571 10.8614 6.08166 10.4495C6.4776 10.0376 7.1325 10.0246 7.54442 10.4205L10.7152 13.4684L16.4559 7.95031C16.8678 7.55437 17.5227 7.56732 17.9187 7.97923Z",
    fill: "#00BB8E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.4826 8.29284C17.8494 8.67264 17.8374 9.27646 17.4558 9.64153L10.8097 16L6.54422 11.9191C6.16264 11.554 6.15065 10.9502 6.51743 10.5704C6.88421 10.1906 7.49087 10.1787 7.87245 10.5438L10.8097 13.3539L16.1276 8.26618C16.5091 7.90111 17.1158 7.91305 17.4826 8.29284Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBenefitCheck);
export default __webpack_public_path__ + "static/media/benefitCheck.34c4c8c48bad64c20e6a8d2a95f81ea7.svg";
export { ForwardRef as ReactComponent };